import { Storage } from '@/classes/Storage';

export default {
  user: Storage.get('user'),
  token: Storage.get('api_token'),
};
